<template>
  <div id="lxts">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title" v-if="$route.params.nr==='lxwm'">联系我们</div>
        <div class="title" v-if="$route.params.nr==='tsjy'">投诉建议</div>
      </div>
    </header>
    <div v-if="$route.params.nr==='lxwm'">
      <div class="tab">
        <a @click="index=1" :class="{ active: index===1}">客服电话</a>
        <a @click="index=2" :class="{ active: index===2}">电子邮箱</a>
        <a @click="index=3" :class="{ active: index===3}">在线客服</a>
      </div>
      <div v-if="index===1" class="wrapper min-height">
        <div class="dh1"></div>
        <div class="ldh1"><a href="tel:4008-889-889">4008-889-889</a></div>
      </div>
      <div v-if="index===2" class="wrapper min-height">
        <div class="yx1"></div>
        <div class="lyx1"><a href="mailto:service@kiiik.com">service@kiiik.com</a></div>
      </div>
      <div v-if="index===3" class="wrapper min-height">
        <div class="kf"></div>
        <!-- <div class="lkf"
             onclick="window.open('https://chat32.live800.com/live800/chatClient/chatbox.jsp?companyID=136542&configID=51541&lan=zh&jid=8820080648&enterurl=http%3A%2F%2Fhelp%2Ekiiik%2Ecom%2Fkiiikhelp%2Fhelp%2Fuserquestiontypelist%2Edo%3Fmethod%3DgetFaq%26param%3Dqh&timestamp=1392018651363&pagereferrer=http%3A%2F%2F180%2E169%2E108%2E246%2Fservice%2Fservicemain%2Ejsp&pagetitle=','_blank')">
          在线客服22
        </div> -->
        <div class="lkf"
          @click="goHref()"
          >
            在线客服
        </div>
      </div>
    </div>
    <div v-if="$route.params.nr==='tsjy'">
      <div class="tab">
        <a @click="index=1" :class="{ active: index!==2}">投诉电话</a>
        <a @click="index=2" :class="{ active: index===2}">投诉邮箱</a>
      </div>
      <div v-if="index!==2" class="wrapper min-height">
        <div class="dh"></div>
        <div class="ldh"><a href="tel:021-23502945">021-23502945</a></div>
      </div>
      <div v-if="index===2" class="wrapper min-height">
        <div class="yx"></div>
        <div class="lyx"><a href="mailto:qhts@kiiik.com">qhts@kiiik.com</a></div>
      </div>
    </div>
    <ICP></ICP>
  </div>
</template>

<script>
  /* eslint-disable */
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import ajax from '@/common/ajax/ajax'
  export default {
    name: 'lxts',
    data () {
      return {
        index: 1
      }
    },
    components: {
      OffCanvas,
      ICP
    },
    methods:{
      goHref(){
        var newWindow = window.open();
        ajax.getOnline().then(
          data => {
            newWindow.location.href = data.data.data
            location.reload();
          }
        )

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #lxts
    .tab
      padding 0 $bj 0 $bj
      background-color $color2
      font-size $font_size2
      color $font_color3
      height 40px
      line-height 40px
      text-align center
      a
        padding 0 15px 0 15px
        border-right solid 1px #a3b8ea
        &.active
          color $font_color2
        &:last-child
          border-right 0
    .wrapper
      padding 0 $bj 0 $bj
      text-align center
      .dh
        margin 45px 0 28px 0
        bg-image('投诉电话', 68px, 72px)
      .ldh
        font-size 18px
        color #f4756f
        text-decoration: underline
        margin-bottom 10px
      .yx
        margin 45px 0 28px 0
        bg-image('投诉邮箱', 68px, 72px)
      .lyx
        font-size 18px
        color #e1b765
        text-decoration: underline
      .kf
        margin 45px 0 28px 0
        bg-image('对话', 68px, 72px)
      .lkf
        font-size 18px
        color #4f6fc0
        text-decoration: underline
      .dh1
        margin 45px 0 28px 0
        bg-image('客服电话', 68px, 72px)
      .ldh1
        font-size 18px
        color #3d9ebe
        text-decoration: underline
        margin-bottom 10px
      .yx1
        margin 45px 0 28px 0
        bg-image('客服邮箱', 68px, 72px)
      .lyx1
        font-size 18px
        color #435182
        text-decoration: underline
</style>



// WEBPACK FOOTER //
// lxts.vue?42e80290